<template>
  <div>
    <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
        <a
          href="/enterprise/#/list?field=%E9%9B%B6%E5%94%AE%E7%94%B5%E5%95%86&category=%E7%A4%BE%E4%BA%A4%E7%94%B5%E5%95%86"
          target="_blank"
          >更多</a
        >
      </div>

      <Company />
    </div>

    <Email />

    <div class="right-box">
      <div class="right-title">
        <span>热门投诉</span>
        <a href="/Index/complain.html" target="_blank">我要投诉</a>
      </div>
      <ul class="platform">
        <li
          v-for="(i, index) of platform"
          :key="index"
          @click="getPlatform(index)"
        >
          {{ i }}
          <i class="fa fa-fire fa-lg"></i>
        </li>
      </ul>
    </div>
    <div style="width: 365px">
      <!-- <a href="https://www.100ec.cn/zt/wswjsxfpgyl/" target="_blank">
        <img style="width: 100%" src="/Public/home/images/zyttk/xfpjr1.jpg" />
      </a> -->
      <a>
        <img style="width: 100%" src="/Public/home/images/cpfw-2025-7-10/szls.jpg" />
      </a>
    </div>
    <!-- <div style="width: 365px; margin-top: 20px">
      <a>
        <img
          style="width: 100%"
          src="/Public/home/images/zyttk/zytgg/szdst.jpg"
        />
      </a>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "ContentR",
  data() {
    return {
      params: {
        field: "数字零售",
        tabs: ["社交电商"],
      },
      year: "",
      time: "",
      platform: [],
    };
  },
  created() {
    this.$store.commit("getCompanyTabs", this.params);
  },
  mounted() {
    if (new Date().getMonth >= 2) {
      this.year = new Date().getFullYear();
    } else {
      this.year = new Date().getFullYear() - 1;
      this.time = "whole_year";
    }
    axios
      .get(
        "https://www.100ec.cn/315/api/index.php?_a=product&f=most_company_list&type=" +
          this.$store.state.type +
          "&limit=20&year=" +
          this.year +
          "&time=" +
          this.time
      )
      .then((res) => {
        for (var i of res.data.list) {
          this.platform.push(i.company);
        }
      });
  },
  methods: {
    getPlatform: function (index) {
      window.open(
        "/Index/complain_search.html?company=" + this.platform[index]
      );
    },
  },
};
</script>